import { ChessUserArrow } from '@exports/ChessBoard';
import { IColoredArrow, IPgnVariantMeta } from '@libs/chess/pgn';

const ARROW_COLOR_TO_USER = {
  G: 'green',
  R: 'red',
  Y: 'yellow',
  B: 'blue',
} as const;
const ARROW_COLOR_TO_PGN = {
  green: 'G',
  red: 'R',
  yellow: 'Y',
  blue: 'B',
} as const;

// Стрелки и подсветки клеток (подсветка — стрелка из клетки в саму себя)
// в пользовательские стрелки доски. Чистая функция — для превью без хука
export function mapUserArrows(
  meta?: Pick<IPgnVariantMeta, 'coloredArrows' | 'coloredSquares'>,
): ChessUserArrow[] {
  const result: ChessUserArrow[] = [];
  meta?.coloredArrows?.forEach((a) => {
    result.push({
      type: 'user',
      color: arrowColorToUser(a.color),
      from: a.from,
      to: a.to,
    });
  });
  meta?.coloredSquares?.forEach((s) => {
    result.push({
      type: 'user',
      color: arrowColorToUser(s.color),
      from: s.square,
      to: s.square,
    });
  });
  return result;
}

export function arrowColorToUser(c: IColoredArrow['color']) {
  return ARROW_COLOR_TO_USER[c];
}

export function arrowColorToPgn(c: ChessUserArrow['color']) {
  return ARROW_COLOR_TO_PGN[c];
}
